// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"O7-z"};